import { gql } from '@apollo/client';
import { useParams } from 'react-router';
import { useFilterContext } from '../contexts/FilterContext';
import { useQueryWithMsg } from '../utils/hooks';

// Returns a sectionGroup or farm data object depending on whether
// a sectionGroup is selected.
const useFarmOrSectionGroupData = (
  fragment, // gql fragment
  queryName, // unique query name
  fragmentName, // fragment name used in the gql fragment
  // additional parameters used in the gql fragment
  // each item in the array should be an object with { name, typeString, value }
  parameters = [],
  queryOptions = {}, // options passed to useQuery
) => {
  const additionalParameterString = `${parameters
    .map(({ name, typeString }) => `, $${name}: ${typeString}`)
    .join('')}`;

  const FarmEconQuery = gql`
    ${fragment}
    query Farm${queryName}($farmId: ID!${additionalParameterString}) {
      farm(farmId: $farmId) {
        id
        ...${fragmentName}
      }
    }
  `;
  const SectionGroupEconQuery = gql`
    ${fragment}
    query SectionGroup${queryName}($id: ID!${additionalParameterString}) {
      sectionGroup(id: $id) {
        id
        ...${fragmentName}
      }
    }
  `;

  const { farmId } = useParams();
  const { sectionGroupId } = useFilterContext().state;
  const additionalVariables = parameters.reduce(
    (map, { name, value }) => ({ ...map, [name]: value }),
    {},
  );
  const variables = {
    ...(sectionGroupId ? { id: sectionGroupId } : { farmId }),
    ...additionalVariables,
  };

  const queryResponse = useQueryWithMsg(
    sectionGroupId ? SectionGroupEconQuery : FarmEconQuery,
    { fetchPolicy: 'cache-and-network', variables, ...queryOptions },
  );
  return {
    ...queryResponse,
    data: queryResponse.data?.sectionGroup || queryResponse.data?.farm,
  };
};

export default useFarmOrSectionGroupData;
